
export const MuiTypography = {
  styleOverrides: {
    root: {
      '&.MuiTypography-h2': {
        paddingBottom: "10px !important",
      },
    },
  },
}